import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import useCurrentUser from "~/modules/auth/hooks/useCurrentUser";
import ProfilePhotoUploader from "~/modules/user/components/ProfilePhotoUploader";

import FieldworkerOnboardingForm from "./FieldworkerOnboardingForm";

export default function DashboardFieldworkerOnboarding() {
    const { t } = useTranslation("app");
    const user = useCurrentUser();

    if (!user || !user?.fieldworker) {
        return undefined;
    }

    return (
        <GaiaPageComponent title={t("dashboardComponents.dashboardFieldworkerOnboarding.title")}>
            <Typography mb={5} variant="h3">
                {t("dashboardComponents.dashboardFieldworkerOnboarding.description")}{" "}
            </Typography>
            <ProfilePhotoUploader user={user} />
            <FieldworkerOnboardingForm user={user} />
        </GaiaPageComponent>
    );
}
